export default __webpack_public_path__ + "static/media/banana.3971e4e7.ogg";